module.exports = __webpack_public_path__ + "static/media/hassan_kane.c6ffa442.jpg";